module.exports = __webpack_public_path__ + "img/jieji.9396a7ef.png";